// extracted by mini-css-extract-plugin
export default {"page":"ClosetPage_page__5k4cI","header":"ClosetPage_header__d8XN0","title":"ClosetPage_title__lu70k","subtitle":"ClosetPage_subtitle__HG8dd"};